import React from 'react';
import Select from '../../../components/ui/Select';

const TimezoneSection = ({ timezone, onTimezoneChange, error }) => {
  const timezones = [
    { value: 'UTC+7', label: 'UTC+7 (เวลาประเทศไทย - Thailand)', description: 'Bangkok, Hanoi, Jakarta' },
    { value: 'UTC-12', label: 'UTC-12 (Baker Island)', description: 'Baker Island, Howland Island' },
    { value: 'UTC-11', label: 'UTC-11 (American Samoa)', description: 'Pago Pago, Niue' },
    { value: 'UTC-10', label: 'UTC-10 (Hawaii)', description: 'Honolulu, Tahiti' },
    { value: 'UTC-9', label: 'UTC-9 (Alaska)', description: 'Anchorage, Juneau' },
    { value: 'UTC-8', label: 'UTC-8 (Pacific)', description: 'Los Angeles, Vancouver, Tijuana' },
    { value: 'UTC-7', label: 'UTC-7 (Mountain)', description: 'Denver, Phoenix, Calgary' },
    { value: 'UTC-6', label: 'UTC-6 (Central)', description: 'Chicago, Mexico City, Guatemala' },
    { value: 'UTC-5', label: 'UTC-5 (Eastern)', description: 'New York, Toronto, Lima' },
    { value: 'UTC-4', label: 'UTC-4 (Atlantic)', description: 'Halifax, Caracas, Santiago' },
    { value: 'UTC-3', label: 'UTC-3 (Brasilia)', description: 'São Paulo, Buenos Aires, Montevideo' },
    { value: 'UTC-2', label: 'UTC-2 (Mid-Atlantic)', description: 'South Georgia, Fernando de Noronha' },
    { value: 'UTC-1', label: 'UTC-1 (Azores)', description: 'Azores, Cape Verde' },
    { value: 'UTC+0', label: 'UTC+0 (GMT)', description: 'London, Lisbon, Reykjavik' },
    { value: 'UTC+1', label: 'UTC+1 (Central European)', description: 'Paris, Berlin, Rome, Madrid' },
    { value: 'UTC+2', label: 'UTC+2 (Eastern European)', description: 'Athens, Cairo, Helsinki, Johannesburg' },
    { value: 'UTC+3', label: 'UTC+3 (Moscow)', description: 'Moscow, Istanbul, Riyadh, Nairobi' },
    { value: 'UTC+4', label: 'UTC+4 (Gulf)', description: 'Dubai, Baku, Tbilisi' },
    { value: 'UTC+5', label: 'UTC+5 (Pakistan)', description: 'Karachi, Tashkent, Yekaterinburg' },
    { value: 'UTC+5:30', label: 'UTC+5:30 (India)', description: 'Mumbai, Delhi, Colombo' },
    { value: 'UTC+6', label: 'UTC+6 (Bangladesh)', description: 'Dhaka, Almaty, Omsk' },
    { value: 'UTC+6:30', label: 'UTC+6:30 (Myanmar)', description: 'Yangon, Cocos Islands' },
    { value: 'UTC+8', label: 'UTC+8 (China)', description: 'Beijing, Singapore, Hong Kong, Perth' },
    { value: 'UTC+9', label: 'UTC+9 (Japan)', description: 'Tokyo, Seoul, Pyongyang' },
    { value: 'UTC+9:30', label: 'UTC+9:30 (Central Australia)', description: 'Adelaide, Darwin' },
    { value: 'UTC+10', label: 'UTC+10 (Eastern Australia)', description: 'Sydney, Melbourne, Brisbane' },
    { value: 'UTC+11', label: 'UTC+11 (Solomon Islands)', description: 'Honiara, Noumea, Magadan' },
    { value: 'UTC+12', label: 'UTC+12 (New Zealand)', description: 'Auckland, Wellington, Fiji' },
    { value: 'UTC+13', label: 'UTC+13 (Tonga)', description: "Nuku'alofa, Apia" },
    { value: 'UTC+14', label: 'UTC+14 (Line Islands)', description: 'Kiritimati' }
  ];

  return (
    <div className="space-y-4 md:space-y-6">
      <div>
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-3 md:mb-4">
          เขตเวลา
        </h3>
        <p className="text-xs md:text-sm text-muted-foreground mb-4">
          Timezone Selection
        </p>
      </div>

      <Select
        label="เลือกเขตเวลา"
        description="Select the timezone for birth location"
        options={timezones}
        value={timezone}
        onChange={onTimezoneChange}
        error={error}
        required
        searchable
        placeholder="เลือกเขตเวลา..."
      />
    </div>
  );
};

export default TimezoneSection;